export enum PAYMENT_METHOD_NAMES {
  SIX = 'Terminal SIX',
  SUMUP = 'SumUp',
  PAYMASH_PAY = 'PaymashPay',
  MYPOS = 'myPOS',
  MYPOS_GLASS = 'myPOS Glass',
  SOFTPOS = 'softPOS',
  OPI = 'OPI protocol',
}
